// components/integrations/shared/DeleteConfirmationModal.tsx
import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { ApiKey } from '../../../types/features/ApiKey';

interface DeleteConfirmationModalProps {
  keyToDelete: ApiKey | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ApiDeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  keyToDelete,
  onConfirm,
  onCancel,
}) => {
  if (!keyToDelete) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6">
        <div className="flex items-center gap-3 text-red-600 mb-4">
          <AlertCircle size={24} />
          <h3 className="text-lg font-semibold">Confirmer la suppression</h3>
        </div>
        <p className="text-slate-600 mb-6">
          Supprimer la clé <strong>"{keyToDelete.name}"</strong> ? Cette action est irréversible.
        </p>
        <div className="flex items-center gap-3">
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors font-medium"
          >
            Supprimer
          </button>
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2.5 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition-colors"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};